import React from 'react';
import PropTypes from 'prop-types';
import { efesGreen } from '../../theme';

const Check = ({ width, height, color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 18 13.423">
    <path
      d="M6.114-.3a.9.9,0,0,0,1.273,0l10.35-10.35a.9.9,0,0,0,0-1.273L16.464-13.2a.9.9,0,0,0-1.273,0L6.75-4.757,2.809-8.7a.9.9,0,0,0-1.273,0L.264-7.425a.9.9,0,0,0,0,1.273Z"
      transform="translate(0 13.461)"
      fill={color}
    />
  </svg>
);

Check.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

Check.defaultProps = {
  width: 18,
  height: 13.423,
  color: efesGreen,
};

export default Check;
